import React, { useState, useEffect, useCallback } from 'react';
import Switch from 'components/Switch';
import Tag from 'components/Tag';
import Icon from 'components/Icon';
import ColorPicker from 'components/ColorPicker';
import Dropdown from 'components/Dropdown';
import useBindToContext from 'hooks/useBindToContext';
import styled from 'styled-components';
import classNames from 'lib/classNames';
import  _ from 'lodash'

const Textarea = ({
	disabled,
	onFocus,
	onBlur,
	inputRef,
	value,
	autofocus,
	placeholder,
	className,
	onChange,
	BindToContext,
	placeholder_color,
	border_color,
	validation = true,
	getError = null,
	specificValidation = null,
	isFlex,
	row= 2
}) => {
	const [BindedValue, BindedOnChange, hasError, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation
	);

	const handleChange = (value) => {
		BindedOnChange(value);
	}
	return (
		<div
			className={classNames(className, 'flex rounded focus-within-ring border', {
				'w-full': !isFlex,
				'bg-gray-300': disabled,
				'bg-white': !disabled,
				'border-red-400': hasError,
			})}
		>
			
			<textarea
				onChange={({ target: { value } }) => handleChange(value)}
				onFocus={(e) => {
					if (onFocus) onFocus(e);
				}}
				disabled={disabled}
				onBlur={(e) => {
					if (onBlur) onBlur(e);
				}}
				placeholder_color={placeholder_color}
				ref={inputRef}
				value={BindedValue}
				row={row}
				placeholder={placeholder}
				className={classNames(
					'border-0 shadow-none min-w-0 w-full appearance-none flex-1 flex-grow py-2 px-3 text-sm text-gray-700 focus:outline-none bg-inherit rounded',
					{
						'placeholder-red-400': hasError,
					}
				)}
				autoFocus={autofocus}
			/>

		</div>
	);
};

Textarea.defaultProps = {
	disabled: false,
	style: {},
	onEnter: false,
	onFocus: false,
	onBlur: false,
	onKeyDown: false,
	inputRef: null,
	BindToContext: null,
	dispatch: null,
	placeholder: '',
	withSwitch: false,
	withNumber: false,
	withDropdown: false,
	value: undefined,
	className: '',
	iconFirst: false,
	placeholder_color: null,
	border_color: null,
	max: null,
	min: null,
};

export default Textarea;
